import React from 'react';

//Components
import { Modal as BaseModal } from '@mui/material';
import Box from '@mui/material/Box';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '96vw', sm: 'auto' },
  minWidth: { sm: '50%' },
  maxWidth: { sm: '90vw' },
  maxHeight: '90vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  borderRadius: 4,
};

export const Modal = props => {
  const { componentChildren, showModal, handleClose } = props;

  return (
    <>
      <BaseModal
        open={showModal}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>{componentChildren}</Box>
      </BaseModal>
    </>
  );
};
